'use strict';

angular.module('businessPlanningModule', [
    'planInitiativeModule',
    'planDeliverableModule'
]);